import React from 'react'

import BrandListV2 from '@zet/feature-brands/screens/brandListV2'

import ScreenViewEventWrapper from '../../webflow/components/screenViewEventWrapper'

const ProductList = () => {
  // const { isNewRecommendationFlow, isNavigationReady, isLoading } =
  //   useRecommendationFlow()

  // if (isLoading || !isNavigationReady) {
  //   return (
  //     <Stack className="flex-1 items-center justify-center">
  //       <ActivityIndicator size="large" color={zetColors.primary[100]} />
  //     </Stack>
  //   )
  // }
  return (
    <ScreenViewEventWrapper screenName="brands_list_new_web_flow_recommendation">
      {/* {isNewRecommendationFlow ? <BrandListV2 /> : <BrandRecommendationList />} */}
      <BrandListV2 />
    </ScreenViewEventWrapper>
  )
}

export default ProductList
